import React from 'react';

export function PlaceIcon({ ...props }: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="currentColor"
      viewBox="0 0 48 48"
      {...props}
    >
      <path d="M24 24c-2.2 0-4-1.8-4-4s1.8-4 4-4 4 1.8 4 4-1.8 4-4 4zm12-3.6C36 13.14 30.7 8 24 8s-12 5.14-12 12.4c0 4.68 3.9 10.88 12 18.28 8.1-7.4 12-13.6 12-18.28zM24 4c8.4 0 16 6.44 16 16.4 0 6.64-5.34 14.5-16 23.6C13.34 34.9 8 27.04 8 20.4 8 10.44 15.6 4 24 4z" />
    </svg>
  );
}
